(() => {
  const selector = '[data-comely-toolbar]';
  let frameRequested = false;
  let scrolled = false;
  let appliedScrollState;
  const offersSeenKey = 'comely-offers-hint-seen-v1';
  let offersSeen = false;
  let offersDialog = null;
  try { offersSeen = sessionStorage.getItem(offersSeenKey) === '1'; } catch {}

  const syncOffersHint = () => {
    const dialog = document.getElementById('ComelyDiscountDialog');
    if (dialog !== offersDialog) {
      offersObserver.disconnect();
      offersDialog = dialog;
      if (dialog) offersObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }
    if (!offersSeen && dialog?.hasAttribute('open')) {
      offersSeen = true;
      try { sessionStorage.setItem(offersSeenKey, '1'); } catch {}
    }
    document.querySelectorAll('[data-comely-offers-hint]').forEach(hint => { hint.hidden = offersSeen; });
  };
  const offersObserver = new MutationObserver(syncOffersHint);

  const sync = () => {
    frameRequested = false;
    // Modal focus/scroll locking is not a user scroll: retain the dock's scale.
    if (document.querySelector('#CartDrawer[open]')) return;
    document.querySelectorAll(selector).forEach((toolbar) => {
      toolbar.classList.toggle('is-scrolled', scrolled);
    });
    appliedScrollState = scrolled;
  };

  const scheduleSync = () => {
    // Read once in the scroll event, before the frame's DOM writes.
    if (document.querySelector('#CartDrawer[open]')) return;
    scrolled = window.scrollY > 24;
    if (scrolled === appliedScrollState) return;
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(sync);
  };

  if (window.comelyMobileToolbarMotion) {
    window.comelyMobileToolbarMotion.sync();
    return;
  }

  const initialize = () => {
    appliedScrollState = undefined;
    scheduleSync();
    syncOffersHint();
  };
  window.comelyMobileToolbarMotion = { sync: initialize };
  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('pageshow', initialize);
  document.addEventListener('shopify:section:load', initialize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
